module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_7042.dd02a760.png";